import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Ng1WebrtcUtilsService } from '../../shared/ng1/ng1-webrtc-utils.service';

@Component({
  selector: 'cc-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  @Input() results = new BehaviorSubject([]);
  public connectedUser: {
    id: string;
  };

  constructor(private webrtcUtilsService: Ng1WebrtcUtilsService) {}

  ngOnInit() {}

  listenAgent(user) {
    this.webrtcUtilsService.webRtcUtil.initWebRtcListener();
    this.webrtcUtilsService.webRtcUtil.startListening(user.id).then(res => {
      if (res.status === 200) {
        this.connectedUser = user;
      } else {
        throw new Error(res.data);
      }
    });
  }

  stopListening() {
    this.webrtcUtilsService.webRtcUtil.stopListening();
    this.connectedUser = null;
  }

  isWiredUser(user) {
    return this.connectedUser && user.id === this.connectedUser.id;
  }

  isUserBusy(user) {
    return user.agentState === 'BUSY';
  }
}
